// Chaves para localStorage
export const THEME_STORAGE_KEYS = {
  TENANT_THEME: "app_tenant_theme",
  IS_DARK_MODE: "app_is_dark_mode",
  WHITELABEL_ENABLED: "app_whitelabel_enabled",
  CURRENT_TENANT_ID: "app_current_tenant_id",
  THEME_INITIALIZED: "app_theme_initialized",
};

// Chaves para controle de sessão
export const SESSION_STORAGE_KEYS = {
  LAST_HOST: "app_last_host",
  LAST_TENANT: "app_last_tenant",
  LAST_USER_ID: "app_last_user_id",
  THEME_LOADED: "app_theme_loaded",
};

// Valores padrão
export const DEFAULT_VALUES = {
  PRIMARY_COLOR: "#7C3AED",
  SECONDARY_COLOR: "#52c41a",
  FAVICON_PATH: "/favicon.ico",
  DEFAULT_TITLE: "Sistema",
  TENANT_NAME_FALLBACK: "Tenant Padrão",
};

// Configurações de host
export const HOST_CONFIG = {
  TEST_HOST: "lbconsultoria.data4company.com.br",
  DOMAIN_IDENTIFIER: "data4company",
  MIN_HOST_PARTS: 3,
};